module.exports = __webpack_public_path__ + "src/assets/img/girl_right_6.edf5593b.png";